export default function orderByPosition(a, b) {
  return a.position - b.position;
}
